'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMapStateToProps = createMapStateToProps;

var _createIntlObject = require('./createIntlObject');

var _createIntlObject2 = _interopRequireDefault(_createIntlObject);

var _intlSelector = require('./intlSelector');

var _intlSelector2 = _interopRequireDefault(_intlSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMapStateToProps() {
  var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _intlSelector2.default;

  return function (state) {
    var intl = selector(state);

    return {
      intl: (0, _createIntlObject2.default)(intl),
      key: intl.locale
    };
  };
}

exports.default = createMapStateToProps;


//////////////////
// WEBPACK FOOTER
// ./~/redux-intl-connect/lib/createMapStateToProps.js
// module id = 121
// module chunks = 0